import React, { memo } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const FEATURE_LABELS = {
  enableStarCodes: 'Star Codes',
  enableDisableCallForwarding: 'Device Unavailable Call Forward',
  ext_9override: 'Omit Leading 9',
  updateFaxSelection: 'Enhanced Fax',
  updateAutoDcSwitchingForBox: 'Data Center Auto Select',
  toggleBoxInternationalCalling: 'International Dialing',
  update3digitdiallinglist: '3-Digit Dialing',
  enableRecording: 'Call Recording',
  updateDbcaAlerts: 'DBCA Alerts',
  updateBoxDeviceFeature: 'Call Rejection / Blocking',
  configureAdvancedRouting: 'Enhanced Routing',
  boxRegistrar: 'Registration Offset',
  powerSaveEnable: 'Power Save',
  powerSaveSchedule: 'Power Save Schedule',
  advancedMonitoring: 'Advanced Monitoring',
  lowMtu: 'Low MTU',
  failOverOptions: 'Failover Options',
  OOBM: 'Out of Band Management',
  activateE3: 'E3 Passthrough',
};

const friendlyFeature = feature => FEATURE_LABELS[feature] || feature;

const DeviceSwapResultModal = memo(({ isOpen, result, onClose }) => {
  if (!result) return null;
  const failedFeatures = Array.isArray(result.failedFeatures) ? result.failedFeatures : [];
  const portErrors = Array.isArray(result.errorResp) ? result.errorResp : [];
  const succeeded = !!result.success;
  const hasIssues = failedFeatures.length > 0 || portErrors.length > 0;

  return (
    <Modal isOpen={isOpen} size="md" id="device-swap-result-modal" zIndex={20000}>
      <ModalHeader>
        {succeeded ? 'Device Swap Complete' : 'Device Swap Unsuccessful'}
      </ModalHeader>
      <ModalBody>
        <p className="mb-3">{result.message || (succeeded ? 'Device swap finished.' : 'Device swap failed.')}</p>
        {succeeded && !hasIssues && (
          <p className="mb-0 text-muted">All ports and features transferred successfully.</p>
        )}
        {portErrors.length > 0 && (
          <div className="mb-3">
            <strong>Port swap issues</strong>
            <ul className="mb-0 mt-2">
              {portErrors.map((item, index) => (
                <li key={`port-${index}`}>
                  EPI {item.obi}: {item.reason || 'Swap failed'}
                </li>
              ))}
            </ul>
          </div>
        )}
        {failedFeatures.length > 0 && (
          <div>
            <strong>Features that did not transfer</strong>
            <ul className="mb-0 mt-2">
              {failedFeatures.map((item, index) => (
                <li key={`feat-${index}`}>
                  {friendlyFeature(item.feature)}
                  {item.message ? ` — ${item.message}` : ''}
                </li>
              ))}
            </ul>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
});

export default DeviceSwapResultModal;
